export const timestampToTime = {
    // data() {
    //   return {

    //   };
    // },
    watch: {
        keywordQuery(newVal) {
            if (!newVal) {
                this.getData()
            }
        }
    },
    methods: {
        // 时间戳格式化
        timestampToTime(time) {
            let date = new Date(time * 1000);
            let Y = date.getFullYear() + "-";
            let M =
                (date.getMonth() + 1 < 10
                    ? "0" + (date.getMonth() + 1)
                    : date.getMonth()) + "-";
            let D =
                (date.getDate() + 1 < 10
                    ? "0" + (date.getDate() + 1)
                    : date.getDate()) + " ";
            let h = (date.getHours() + 1 < 10
                ? "0" + (date.getHours())
                : date.getHours()) + ":";
            let m =
                (date.getMinutes() + 1 < 10
                    ? "0" + (date.getMinutes())
                    : date.getMinutes()) + ":";
            let s =
                date.getSeconds() + 1 < 10
                    ? "0" + (date.getSeconds() + 1)
                    : date.getSeconds();
            return Y + M + D + h + m + s;
        },

        // 创建时间 格式化显示
        addTime(row) {
            let time = this.timestampToTime(row.add_time)
            return time
        },

        //  更新时间 格式化显示
        updateTime(row) {
            let time = this.timestampToTime(row.update_time)
            return time
        },

        //改变每页显示数量重新请求数据，重置当前页为第一页
        handleSizeChange(val) {
            let pageSize = { pagesize: val };
            this.getData(pageSize);
        },

        //点击改变当前页
        handleCurrentChange(val) {
            let page = { page: val };
            this.getData(page);
        },

        // 查询参数
        queryData() {
            let data = {
                q: this.keywordQuery
            };
            if (data.q) {
                this.getData(data);
            } else {
                this.getData();
            }
        }
    }
};
